module.exports = __webpack_public_path__ + "static/flatart_slider_mobile-c640858c160f422de273d8e73a6ba483.jpg";